var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('typical',{staticClass:"blink my-5 typicalWrapper",attrs:{"steps":['Thank you 👋 for doing business with us.', 1000, 'Thank you 👋 for choosing Lendarc.', 1000],"loop":Infinity,"wrapper":'h2'}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"dot-flashing"})])
}]

export { render, staticRenderFns }